import svgPaths from './svg-44tamkblwk';

function ActiveHelper({ children }: React.PropsWithChildren<{}>) {
  return (
    <svg
      fill="none"
      preserveAspectRatio="none"
      viewBox="0 0 1120 1120"
      className="absolute block size-full"
    >
      <g id="Vector">{children}</g>
    </svg>
  );
}
type ActiveProps = {
  className?: string;
  property1?: '1' | '2' | 'Variant3' | 'Variant4';
  state?: 'running' | 'stopping';
};

function Active({ className, property1 = '1', state = 'running' }: ActiveProps) {
  if (property1 === '2' && state === 'running') {
    return (
      <div
        className={className || 'relative size-[1120px]'}
        data-name="Property 1=2, state=running"
      >
        <ActiveHelper>
          <path d={svgPaths.p2284cdc0} fill="#2D178B" />
          <path d={svgPaths.p25a7aa00} fill="#2D178B" />
          <path d={svgPaths.p2fffee00} fill="#2D178B" />
          <path d={svgPaths.p14a5b500} fill="#2D178B" />
          <path d={svgPaths.p289fb080} fill="#2D178B" />
          <path d={svgPaths.p3fd75200} fill="#2D178B" />
          <path d={svgPaths.p2ecac0f2} fill="#2D178B" />
          <path d={svgPaths.p286b5e70} fill="#2D178B" />
          <path d={svgPaths.p3b6f7e00} fill="#2D178B" />
          <path d={svgPaths.p2828f0c0} fill="#2D178B" />
          <path d={svgPaths.p272e5600} fill="#2D178B" />
          <path d={svgPaths.p15b0fd40} fill="#2D178B" />
          <path d={svgPaths.p18e03f80} fill="#2D178B" />
          <path d={svgPaths.p39edcc00} fill="#2D178B" />
          <path d={svgPaths.p28b6000} fill="#2D178B" />
          <path d={svgPaths.p18c40c80} fill="#2D178B" />
          <path d={svgPaths.p28b46580} fill="#2D178B" />
          <path d={svgPaths.pf6e9580} fill="#2D178B" />
          <path d={svgPaths.p1252af00} fill="#2D178B" />
          <path d={svgPaths.pede4a00} fill="#2D178B" />
          <path d={svgPaths.p18c64700} fill="#2D178B" />
          <path d={svgPaths.p29a2e980} fill="#2D178B" />
          <path d={svgPaths.p2c9dd670} fill="#2D178B" />
          <path d={svgPaths.p234aac00} fill="#2D178B" />
          <path d={svgPaths.p2447b400} fill="#2D178B" />
          <path d={svgPaths.p1090400} fill="#2D178B" />
          <path d={svgPaths.p259d7a70} fill="#2D178B" />
          <path d={svgPaths.p14056780} fill="#2D178B" />
          <path d={svgPaths.p29024d00} fill="#2D178B" />
          <path d={svgPaths.p2e9bf2f0} fill="#2D178B" />
          <path d={svgPaths.p7ea6000} fill="#2D178B" />
          <path d={svgPaths.p1145ee00} fill="#2D178B" />
          <path d={svgPaths.pce8ae80} fill="#2D178B" />
          <path d={svgPaths.p3cec9100} fill="#2D178B" />
          <path d={svgPaths.p19d02a00} fill="#2D178B" />
          <path d={svgPaths.p3b483400} fill="#2D178B" />
          <path d={svgPaths.p26f0c480} fill="#2D178B" />
          <path d={svgPaths.p151f8800} fill="#2D178B" />
          <path d={svgPaths.p27febd00} fill="#2D178B" />
          <path d={svgPaths.p2fc38f00} fill="#2D178B" />
          <path d={svgPaths.p5ff0870} fill="#2D178B" />
          <path d={svgPaths.p15cc1680} fill="#2D178B" />
          <path d={svgPaths.p10a30880} fill="#2D178B" />
          <path d={svgPaths.p175c9c00} fill="#2D178B" />
          <path d={svgPaths.p2013a300} fill="#2D178B" />
          <path d={svgPaths.p3e7c1080} fill="#2D178B" />
          <path d={svgPaths.p31e5cc80} fill="#2D178B" />
          <path d={svgPaths.p20957d00} fill="#2D178B" />
          <path d={svgPaths.p3e2df400} fill="#2D178B" />
          <path d={svgPaths.p259f8700} fill="#2D178B" />
          <path d={svgPaths.p36a044c0} fill="#2D178B" />
          <path d={svgPaths.p5c29e00} fill="#2D178B" />
          <path d={svgPaths.p3ab629f0} fill="#2D178B" />
          <path d={svgPaths.p251ed700} fill="#2D178B" />
          <path d={svgPaths.p5374c80} fill="#2D178B" />
          <path d={svgPaths.p287cd600} fill="#2D178B" />
          <path d={svgPaths.pad26370} fill="#2D178B" />
          <path d={svgPaths.p18125800} fill="#2D178B" />
          <path d={svgPaths.p192eb800} fill="#2D178B" />
          <path d={svgPaths.p39ccf680} fill="#2D178B" />
          <path d={svgPaths.p5379600} fill="#2D178B" />
          <path d={svgPaths.p61f2500} fill="#2D178B" />
          <path d={svgPaths.p19e27240} fill="#2D178B" />
          <path d={svgPaths.p1b619400} fill="#2D178B" />
          <path d={svgPaths.p2b92fc00} fill="#2D178B" />
          <path d={svgPaths.p659b0f0} fill="#2D178B" />
          <path d={svgPaths.p2c1a6e00} fill="#2D178B" />
          <path d={svgPaths.pac15c00} fill="#2D178B" />
          <path d={svgPaths.p2a434700} fill="#2D178B" />
          <path d={svgPaths.p358f6b00} fill="#2D178B" />
          <path d={svgPaths.p1c888d00} fill="#2D178B" />
          <path d={svgPaths.p379a8f00} fill="#2D178B" />
          <path d={svgPaths.p25e34680} fill="#2D178B" />
          <path d={svgPaths.p1002df0} fill="#2D178B" />
          <path d={svgPaths.p17ef4100} fill="#2D178B" />
          <path d={svgPaths.p19f14400} fill="#2D178B" />
          <path d={svgPaths.pe86b200} fill="#2D178B" />
          <path d={svgPaths.p20434780} fill="#2D178B" />
          <path d={svgPaths.p107c9580} fill="#2D178B" />
          <path d={svgPaths.p32746f00} fill="#2D178B" />
          <path d={svgPaths.p1fa9c100} fill="#2D178B" />
          <path d={svgPaths.p16ee7600} fill="#2D178B" />
          <path d={svgPaths.p1b3bd400} fill="#2D178B" />
          <path d={svgPaths.p86bddc0} fill="#2D178B" />
          <path d={svgPaths.p2e7e7900} fill="#2D178B" />
          <path d={svgPaths.pe00d430} fill="#2D178B" />
          <path d={svgPaths.p23123a0} fill="#2D178B" />
          <path d={svgPaths.p1a155650} fill="#2D178B" />
          <path d={svgPaths.pc6f9000} fill="#2D178B" />
          <path d={svgPaths.p398ef080} fill="#2D178B" />
          <path d={svgPaths.p97c9300} fill="#2D178B" />
          <path d={svgPaths.p10a9a900} fill="#2D178B" />
          <path d={svgPaths.p1919bc80} fill="#2D178B" />
          <path d={svgPaths.pf0e9280} fill="#2D178B" />
          <path d={svgPaths.p1379b400} fill="#2D178B" />
          <path d={svgPaths.p13e59a80} fill="#2D178B" />
          <path d={svgPaths.p39295200} fill="#2D178B" />
          <path d={svgPaths.pe8e4d40} fill="#2D178B" />
          <path d={svgPaths.p34e3e000} fill="#2D178B" />
          <path d={svgPaths.pb552100} fill="#2D178B" />
          <path d={svgPaths.p1aba7a00} fill="#2D178B" />
          <path d={svgPaths.p3db04400} fill="#2D178B" />
          <path d={svgPaths.pe7ad100} fill="#2D178B" />
          <path d={svgPaths.p6965ff0} fill="#2D178B" />
          <path d={svgPaths.p1f993e70} fill="#2D178B" />
          <path d={svgPaths.p1ef342f0} fill="#2D178B" />
          <path d={svgPaths.p26ce9b00} fill="#2D178B" />
          <path d={svgPaths.p11ac9900} fill="#2D178B" />
          <path d={svgPaths.p117cc00} fill="#2D178B" />
          <path d={svgPaths.p3aff1200} fill="#2D178B" />
          <path d={svgPaths.p24b24200} fill="#2D178B" />
          <path d={svgPaths.p66a81c0} fill="#2D178B" />
          <path d={svgPaths.pb23d4c0} fill="#2D178B" />
          <path d={svgPaths.p3731aa00} fill="#2D178B" />
          <path d={svgPaths.p38ed0d00} fill="#2D178B" />
          <path d={svgPaths.p3a54b9c0} fill="#2D178B" />
          <path d={svgPaths.p2c641c00} fill="#2D178B" />
          <path d={svgPaths.p1f1cdb00} fill="#2D178B" />
          <path d={svgPaths.p2cbbc400} fill="#2D178B" />
          <path d={svgPaths.p1950e500} fill="#2D178B" />
          <path d={svgPaths.p282cf380} fill="#2D178B" />
          <path d={svgPaths.p620e900} fill="#2D178B" />
          <path d={svgPaths.p1a317370} fill="#2D178B" />
          <path d={svgPaths.p2a9f2c00} fill="#2D178B" />
          <path d={svgPaths.p1f7e4c00} fill="#2D178B" />
          <path d={svgPaths.p13a6c300} fill="#2D178B" />
          <path d={svgPaths.p1ee8d000} fill="#2D178B" />
          <path d={svgPaths.p1234d8c0} fill="#2D178B" />
          <path d={svgPaths.p5984a00} fill="#2D178B" />
          <path d={svgPaths.p9bc2900} fill="#2D178B" />
          <path d={svgPaths.p10c5cf00} fill="#2D178B" />
          <path d={svgPaths.pa003d80} fill="#2D178B" />
          <path d={svgPaths.p294ffd80} fill="#2D178B" />
          <path d={svgPaths.p1a4b7e80} fill="#2D178B" />
          <path d={svgPaths.p201deb00} fill="#2D178B" />
        </ActiveHelper>
      </div>
    );
  }
  if (property1 === 'Variant4' && state === 'stopping') {
    return (
      <button
        className={className || 'block cursor-pointer relative size-[1120px]'}
        data-name="Property 1=Variant4, state=stopping"
      >
        <ActiveHelper>
          <path d={svgPaths.p1ad42200} fill="#2D178B" />
          <path d={svgPaths.p20282600} fill="#2D178B" />
          <path d={svgPaths.pc83e070} fill="#2D178B" />
          <path d={svgPaths.pdfd6b00} fill="#2D178B" />
          <path d={svgPaths.p3bbd0d00} fill="#2D178B" />
          <path d={svgPaths.p227d8600} fill="#2D178B" />
          <path d={svgPaths.pb262900} fill="#2D178B" />
          <path d={svgPaths.p3d619a00} fill="#2D178B" />
          <path d={svgPaths.p31696700} fill="#2D178B" />
          <path d={svgPaths.p2692d400} fill="#2D178B" />
          <path d={svgPaths.p2ef5f240} fill="#2D178B" />
          <path d={svgPaths.p3d6a880} fill="#2D178B" />
          <path d={svgPaths.p2f9cc160} fill="#2D178B" />
          <path d={svgPaths.p1fc36600} fill="#2D178B" />
          <path d={svgPaths.p2e605900} fill="#2D178B" />
          <path d={svgPaths.p26d180b0} fill="#2D178B" />
          <path d={svgPaths.p33d44f00} fill="#2D178B" />
          <path d={svgPaths.p3628a00} fill="#2D178B" />
          <path d={svgPaths.pd9e69b0} fill="#2D178B" />
          <path d={svgPaths.p44eab80} fill="#2D178B" />
          <path d={svgPaths.p3974bef0} fill="#2D178B" />
          <path d={svgPaths.p6798b80} fill="#2D178B" />
          <path d={svgPaths.p2ca61fc0} fill="#2D178B" />
          <path d={svgPaths.p11cbed00} fill="#2D178B" />
          <path d={svgPaths.p2e040200} fill="#2D178B" />
          <path d={svgPaths.p91ccc00} fill="#2D178B" />
          <path d={svgPaths.p27437080} fill="#2D178B" />
          <path d={svgPaths.p37fc3600} fill="#2D178B" />
          <path d={svgPaths.p20381ef0} fill="#2D178B" />
          <path d={svgPaths.p2c1aeec0} fill="#2D178B" />
          <path d={svgPaths.p2fd0f780} fill="#2D178B" />
          <path d={svgPaths.pdb10d80} fill="#2D178B" />
          <path d={svgPaths.p1109c030} fill="#2D178B" />
          <path d={svgPaths.p2d486a00} fill="#2D178B" />
          <path d={svgPaths.p2db1c0} fill="#2D178B" />
          <path d={svgPaths.p3bec3200} fill="#2D178B" />
          <path d={svgPaths.p381fa800} fill="#2D178B" />
          <path d={svgPaths.p3cea40f2} fill="#2D178B" />
          <path d={svgPaths.p13217080} fill="#2D178B" />
          <path d={svgPaths.pb593c00} fill="#2D178B" />
          <path d={svgPaths.p15a2ea70} fill="#2D178B" />
          <path d={svgPaths.p195dab80} fill="#2D178B" />
          <path d={svgPaths.pa54b700} fill="#2D178B" />
          <path d={svgPaths.p31b93300} fill="#2D178B" />
          <path d={svgPaths.p492f400} fill="#2D178B" />
          <path d={svgPaths.p4f53d00} fill="#2D178B" />
          <path d={svgPaths.p108c980} fill="#2D178B" />
          <path d={svgPaths.p1fe4e580} fill="#2D178B" />
          <path d={svgPaths.p3bb6300} fill="#2D178B" />
          <path d={svgPaths.p80b9880} fill="#2D178B" />
          <path d={svgPaths.p12e55200} fill="#2D178B" />
          <path d={svgPaths.p31721080} fill="#2D178B" />
          <path d={svgPaths.p8b4b400} fill="#2D178B" />
          <path d={svgPaths.p2a85e900} fill="#2D178B" />
          <path d={svgPaths.pcc21af0} fill="#2D178B" />
          <path d={svgPaths.pbd59900} fill="#2D178B" />
          <path d={svgPaths.p3c608480} fill="#2D178B" />
          <path d={svgPaths.p21a51f80} fill="#2D178B" />
          <path d={svgPaths.p3dcc7000} fill="#2D178B" />
          <path d={svgPaths.p20261480} fill="#2D178B" />
          <path d={svgPaths.p263b1a80} fill="#2D178B" />
          <path d={svgPaths.p2b984900} fill="#2D178B" />
          <path d={svgPaths.p2c4e6a00} fill="#2D178B" />
          <path d={svgPaths.p38502f00} fill="#2D178B" />
          <path d={svgPaths.p3634d500} fill="#2D178B" />
          <path d={svgPaths.p30535c00} fill="#2D178B" />
          <path d={svgPaths.p317d1180} fill="#2D178B" />
          <path d={svgPaths.p2c847d00} fill="#2D178B" />
          <path d={svgPaths.p2a3b3a00} fill="#2D178B" />
          <path d={svgPaths.p2528a900} fill="#2D178B" />
          <path d={svgPaths.p1ccf172} fill="#2D178B" />
          <path d={svgPaths.p177de600} fill="#2D178B" />
          <path d={svgPaths.p3eb39380} fill="#2D178B" />
          <path d={svgPaths.p1759fdf2} fill="#2D178B" />
          <path d={svgPaths.p1a73d200} fill="#2D178B" />
          <path d={svgPaths.p1c84b800} fill="#2D178B" />
          <path d={svgPaths.p2d16e000} fill="#2D178B" />
          <path d={svgPaths.pc295000} fill="#2D178B" />
          <path d={svgPaths.pa733880} fill="#2D178B" />
          <path d={svgPaths.p1c234100} fill="#2D178B" />
          <path d={svgPaths.p72f9f00} fill="#2D178B" />
          <path d={svgPaths.p12f070} fill="#2D178B" />
          <path d={svgPaths.p2e0c6b00} fill="#2D178B" />
          <path d={svgPaths.p10c6be00} fill="#2D178B" />
          <path d={svgPaths.p2989ed80} fill="#2D178B" />
          <path d={svgPaths.p3c20f900} fill="#2D178B" />
          <path d={svgPaths.p13310a00} fill="#2D178B" />
          <path d={svgPaths.p1d235f00} fill="#2D178B" />
          <path d={svgPaths.pb27d880} fill="#2D178B" />
          <path d={svgPaths.p2f1f5af0} fill="#2D178B" />
          <path d={svgPaths.p1bd1fd00} fill="#2D178B" />
          <path d={svgPaths.p15365400} fill="#2D178B" />
          <path d={svgPaths.p7910430} fill="#2D178B" />
          <path d={svgPaths.p11000d00} fill="#2D178B" />
          <path d={svgPaths.pa89d8b0} fill="#2D178B" />
          <path d={svgPaths.p18dca400} fill="#2D178B" />
        </ActiveHelper>
      </button>
    );
  }
  if (property1 === 'Variant3' && state === 'stopping') {
    return (
      <div
        className={className || 'relative size-[1120px]'}
        data-name="Property 1=Variant3, state=stopping"
      >
        <ActiveHelper>
          <path d={svgPaths.pbcebf00} fill="#2D178B" />
          <path d={svgPaths.p37d8ea70} fill="#2D178B" />
          <path d={svgPaths.p955c70} fill="#2D178B" />
          <path d={svgPaths.p1236b700} fill="#2D178B" />
          <path d={svgPaths.p2af9d7c0} fill="#2D178B" />
          <path d={svgPaths.p28fc0100} fill="#2D178B" />
          <path d={svgPaths.p1758f200} fill="#2D178B" />
          <path d={svgPaths.p3bf04a80} fill="#2D178B" />
          <path d={svgPaths.p38c2ba00} fill="#2D178B" />
          <path d={svgPaths.p3cbbc200} fill="#2D178B" />
          <path d={svgPaths.p22537f80} fill="#2D178B" />
          <path d={svgPaths.p15736f00} fill="#2D178B" />
          <path d={svgPaths.p19162d00} fill="#2D178B" />
          <path d={svgPaths.p212e5ea0} fill="#2D178B" />
          <path d={svgPaths.p2e72600} fill="#2D178B" />
          <path d={svgPaths.p2aa62180} fill="#2D178B" />
          <path d={svgPaths.p4e108e0} fill="#2D178B" />
          <path d={svgPaths.p2face800} fill="#2D178B" />
          <path d={svgPaths.p3cabd500} fill="#2D178B" />
          <path d={svgPaths.p3e55ec00} fill="#2D178B" />
          <path d={svgPaths.p83f54d0} fill="#2D178B" />
          <path d={svgPaths.p5bcb900} fill="#2D178B" />
          <path d={svgPaths.p10c0c280} fill="#2D178B" />
          <path d={svgPaths.p18ca780} fill="#2D178B" />
          <path d={svgPaths.pdbd83f0} fill="#2D178B" />
          <path d={svgPaths.p28092b00} fill="#2D178B" />
          <path d={svgPaths.p3ae62d80} fill="#2D178B" />
          <path d={svgPaths.p6fec300} fill="#2D178B" />
          <path d={svgPaths.padce880} fill="#2D178B" />
          <path d={svgPaths.p2adf3300} fill="#2D178B" />
          <path d={svgPaths.p3a8d1100} fill="#2D178B" />
          <path d={svgPaths.p1336e300} fill="#2D178B" />
          <path d={svgPaths.p1351e500} fill="#2D178B" />
          <path d={svgPaths.p18189200} fill="#2D178B" />
          <path d={svgPaths.p1915ef00} fill="#2D178B" />
          <path d={svgPaths.p3ca55380} fill="#2D178B" />
          <path d={svgPaths.p24f40770} fill="#2D178B" />
          <path d={svgPaths.p1c81fb00} fill="#2D178B" />
          <path d={svgPaths.p219d9200} fill="#2D178B" />
          <path d={svgPaths.p159d7580} fill="#2D178B" />
          <path d={svgPaths.p21353900} fill="#2D178B" />
          <path d={svgPaths.p480b6c0} fill="#2D178B" />
          <path d={svgPaths.p20860380} fill="#2D178B" />
          <path d={svgPaths.pc931880} fill="#2D178B" />
          <path d={svgPaths.p74c6f00} fill="#2D178B" />
          <path d={svgPaths.p31b17100} fill="#2D178B" />
          <path d={svgPaths.p154dccf0} fill="#2D178B" />
          <path d={svgPaths.p218f8000} fill="#2D178B" />
          <path d={svgPaths.p3e964900} fill="#2D178B" />
          <path d={svgPaths.p20e77b00} fill="#2D178B" />
          <path d={svgPaths.p6a5f500} fill="#2D178B" />
          <path d={svgPaths.p27249800} fill="#2D178B" />
          <path d={svgPaths.p17a3b00} fill="#2D178B" />
          <path d={svgPaths.p347e4480} fill="#2D178B" />
          <path d={svgPaths.p219cd700} fill="#2D178B" />
          <path d={svgPaths.p71a3300} fill="#2D178B" />
          <path d={svgPaths.p126ec480} fill="#2D178B" />
          <path d={svgPaths.peb3c080} fill="#2D178B" />
          <path d={svgPaths.pe293600} fill="#2D178B" />
          <path d={svgPaths.p169a2800} fill="#2D178B" />
          <path d={svgPaths.p3bc11a40} fill="#2D178B" />
          <path d={svgPaths.pcd55300} fill="#2D178B" />
          <path d={svgPaths.p1a498480} fill="#2D178B" />
          <path d={svgPaths.p364a0540} fill="#2D178B" />
          <path d={svgPaths.p12974f00} fill="#2D178B" />
          <path d={svgPaths.p1cdf0200} fill="#2D178B" />
          <path d={svgPaths.p20380500} fill="#2D178B" />
          <path d={svgPaths.p127d0a00} fill="#2D178B" />
          <path d={svgPaths.peefd500} fill="#2D178B" />
          <path d={svgPaths.p26626800} fill="#2D178B" />
          <path d={svgPaths.p39848200} fill="#2D178B" />
          <path d={svgPaths.p29c72d00} fill="#2D178B" />
          <path d={svgPaths.pe07ca00} fill="#2D178B" />
          <path d={svgPaths.p1eae2580} fill="#2D178B" />
          <path d={svgPaths.pab50a70} fill="#2D178B" />
          <path d={svgPaths.p3c6b9180} fill="#2D178B" />
          <path d={svgPaths.p103914c0} fill="#2D178B" />
          <path d={svgPaths.p115de700} fill="#2D178B" />
          <path d={svgPaths.p7822200} fill="#2D178B" />
          <path d={svgPaths.p19dbd600} fill="#2D178B" />
          <path d={svgPaths.p3d25a000} fill="#2D178B" />
          <path d={svgPaths.p19ef0a00} fill="#2D178B" />
          <path d={svgPaths.p2d608d80} fill="#2D178B" />
          <path d={svgPaths.p110d6d00} fill="#2D178B" />
          <path d={svgPaths.p15c70e00} fill="#2D178B" />
          <path d={svgPaths.p17f03400} fill="#2D178B" />
          <path d={svgPaths.p292be870} fill="#2D178B" />
          <path d={svgPaths.p5c28900} fill="#2D178B" />
          <path d={svgPaths.p35821980} fill="#2D178B" />
          <path d={svgPaths.p36121300} fill="#2D178B" />
          <path d={svgPaths.pb53c700} fill="#2D178B" />
          <path d={svgPaths.p3e9d700} fill="#2D178B" />
          <path d={svgPaths.pedb3f00} fill="#2D178B" />
          <path d={svgPaths.p1d0ea770} fill="#2D178B" />
          <path d={svgPaths.p2bf93f00} fill="#2D178B" />
          <path d={svgPaths.p38781e00} fill="#2D178B" />
          <path d={svgPaths.p2e60c700} fill="#2D178B" />
          <path d={svgPaths.p2621b700} fill="#2D178B" />
          <path d={svgPaths.p2d414d00} fill="#2D178B" />
          <path d={svgPaths.p682c200} fill="#2D178B" />
          <path d={svgPaths.pfbba070} fill="#2D178B" />
          <path d={svgPaths.p214e7400} fill="#2D178B" />
          <path d={svgPaths.p115ca700} fill="#2D178B" />
          <path d={svgPaths.p12dc0500} fill="#2D178B" />
          <path d={svgPaths.p36702600} fill="#2D178B" />
          <path d={svgPaths.p9253900} fill="#2D178B" />
          <path d={svgPaths.p32be4b80} fill="#2D178B" />
          <path d={svgPaths.p15b9e700} fill="#2D178B" />
          <path d={svgPaths.p29c8a780} fill="#2D178B" />
          <path d={svgPaths.p1ca13900} fill="#2D178B" />
        </ActiveHelper>
      </div>
    );
  }
  return (
    <button
      className={className || 'block cursor-pointer relative size-[1120px]'}
      data-name="Property 1=1, state=running"
    >
      <ActiveHelper>
        <path d={svgPaths.p17f5c680} fill="#2D178B" />
        <path d={svgPaths.p10f1d000} fill="#2D178B" />
        <path d={svgPaths.p11731680} fill="#2D178B" />
        <path d={svgPaths.p2b945000} fill="#2D178B" />
        <path d={svgPaths.pf3f8700} fill="#2D178B" />
        <path d={svgPaths.p239f4800} fill="#2D178B" />
        <path d={svgPaths.p2343ea00} fill="#2D178B" />
        <path d={svgPaths.p36761400} fill="#2D178B" />
        <path d={svgPaths.pb8a6630} fill="#2D178B" />
        <path d={svgPaths.p5886580} fill="#2D178B" />
        <path d={svgPaths.p35633100} fill="#2D178B" />
        <path d={svgPaths.p192ec900} fill="#2D178B" />
        <path d={svgPaths.p23afd172} fill="#2D178B" />
        <path d={svgPaths.pd2566b0} fill="#2D178B" />
        <path d={svgPaths.p8d959f0} fill="#2D178B" />
        <path d={svgPaths.p360c5f00} fill="#2D178B" />
        <path d={svgPaths.p3e2c2e00} fill="#2D178B" />
        <path d={svgPaths.p1469b400} fill="#2D178B" />
        <path d={svgPaths.p1b1da580} fill="#2D178B" />
        <path d={svgPaths.p149e7200} fill="#2D178B" />
        <path d={svgPaths.pf4d400} fill="#2D178B" />
        <path d={svgPaths.p395b8e70} fill="#2D178B" />
        <path d={svgPaths.p1b28bb00} fill="#2D178B" />
        <path d={svgPaths.p8cfb500} fill="#2D178B" />
        <path d={svgPaths.pfe8b000} fill="#2D178B" />
        <path d={svgPaths.p1299c500} fill="#2D178B" />
        <path d={svgPaths.p26be5800} fill="#2D178B" />
        <path d={svgPaths.p2043be00} fill="#2D178B" />
        <path d={svgPaths.p23646e00} fill="#2D178B" />
        <path d={svgPaths.p9b9fe00} fill="#2D178B" />
        <path d={svgPaths.p3a803980} fill="#2D178B" />
        <path d={svgPaths.p12526300} fill="#2D178B" />
        <path d={svgPaths.pe12bd00} fill="#2D178B" />
        <path d={svgPaths.p3f6a1800} fill="#2D178B" />
        <path d={svgPaths.pd289d00} fill="#2D178B" />
        <path d={svgPaths.p30cdca00} fill="#2D178B" />
        <path d={svgPaths.p206d4400} fill="#2D178B" />
        <path d={svgPaths.p2d457800} fill="#2D178B" />
        <path d={svgPaths.p14a6b4c0} fill="#2D178B" />
        <path d={svgPaths.p3d911100} fill="#2D178B" />
        <path d={svgPaths.p256e12c0} fill="#2D178B" />
        <path d={svgPaths.p1bdd98f2} fill="#2D178B" />
        <path d={svgPaths.p6995580} fill="#2D178B" />
        <path d={svgPaths.p2a8d9bc0} fill="#2D178B" />
        <path d={svgPaths.p194aab70} fill="#2D178B" />
        <path d={svgPaths.p2b5ba600} fill="#2D178B" />
        <path d={svgPaths.p1bad3700} fill="#2D178B" />
        <path d={svgPaths.p3fd88c00} fill="#2D178B" />
        <path d={svgPaths.p14128d80} fill="#2D178B" />
        <path d={svgPaths.p2b92300} fill="#2D178B" />
        <path d={svgPaths.p35cba440} fill="#2D178B" />
        <path d={svgPaths.p9656600} fill="#2D178B" />
        <path d={svgPaths.p29785e80} fill="#2D178B" />
        <path d={svgPaths.p1f33fa00} fill="#2D178B" />
        <path d={svgPaths.p34761b00} fill="#2D178B" />
        <path d={svgPaths.p330e5000} fill="#2D178B" />
        <path d={svgPaths.p38b15400} fill="#2D178B" />
        <path d={svgPaths.p3b24cc00} fill="#2D178B" />
        <path d={svgPaths.p3c2b2dc0} fill="#2D178B" />
        <path d={svgPaths.pe08a300} fill="#2D178B" />
        <path d={svgPaths.p26fb0c30} fill="#2D178B" />
        <path d={svgPaths.pa22d4c0} fill="#2D178B" />
        <path d={svgPaths.p1568f580} fill="#2D178B" />
        <path d={svgPaths.p3c0ea380} fill="#2D178B" />
        <path d={svgPaths.p2865c380} fill="#2D178B" />
        <path d={svgPaths.p2f39cb00} fill="#2D178B" />
        <path d={svgPaths.p6cdbf00} fill="#2D178B" />
        <path d={svgPaths.p1ca52c80} fill="#2D178B" />
        <path d={svgPaths.pb1a1700} fill="#2D178B" />
        <path d={svgPaths.p1972d800} fill="#2D178B" />
        <path d={svgPaths.p6a3d800} fill="#2D178B" />
        <path d={svgPaths.p1062a300} fill="#2D178B" />
        <path d={svgPaths.p343b4c0} fill="#2D178B" />
        <path d={svgPaths.p1d534800} fill="#2D178B" />
        <path d={svgPaths.p6fa6e00} fill="#2D178B" />
        <path d={svgPaths.pe9c2580} fill="#2D178B" />
        <path d={svgPaths.p138f4000} fill="#2D178B" />
        <path d={svgPaths.p399a6d00} fill="#2D178B" />
        <path d={svgPaths.p1de92080} fill="#2D178B" />
        <path d={svgPaths.p1dfdfa00} fill="#2D178B" />
        <path d={svgPaths.p274b9600} fill="#2D178B" />
        <path d={svgPaths.p15d74e00} fill="#2D178B" />
        <path d={svgPaths.p1d90af00} fill="#2D178B" />
        <path d={svgPaths.p20f6f500} fill="#2D178B" />
        <path d={svgPaths.pbf134c0} fill="#2D178B" />
        <path d={svgPaths.pd5af200} fill="#2D178B" />
        <path d={svgPaths.p30a37200} fill="#2D178B" />
        <path d={svgPaths.p1facd2f0} fill="#2D178B" />
        <path d={svgPaths.p20a1a200} fill="#2D178B" />
        <path d={svgPaths.p37e21600} fill="#2D178B" />
        <path d={svgPaths.pf27b500} fill="#2D178B" />
        <path d={svgPaths.p1a4ac400} fill="#2D178B" />
        <path d={svgPaths.pfddad80} fill="#2D178B" />
        <path d={svgPaths.p1ff80800} fill="#2D178B" />
        <path d={svgPaths.p3ce8e500} fill="#2D178B" />
        <path d={svgPaths.p2d107480} fill="#2D178B" />
        <path d={svgPaths.p59dfa80} fill="#2D178B" />
        <path d={svgPaths.p18a13880} fill="#2D178B" />
        <path d={svgPaths.p2f6e9b80} fill="#2D178B" />
        <path d={svgPaths.pa762580} fill="#2D178B" />
        <path d={svgPaths.p113dd1f0} fill="#2D178B" />
        <path d={svgPaths.p2a482f00} fill="#2D178B" />
        <path d={svgPaths.p1603a980} fill="#2D178B" />
        <path d={svgPaths.p34238380} fill="#2D178B" />
        <path d={svgPaths.p4fbb700} fill="#2D178B" />
        <path d={svgPaths.p12c49d00} fill="#2D178B" />
        <path d={svgPaths.p36b93d00} fill="#2D178B" />
        <path d={svgPaths.p17eaf380} fill="#2D178B" />
        <path d={svgPaths.p15d1b5c0} fill="#2D178B" />
        <path d={svgPaths.p16d3f000} fill="#2D178B" />
        <path d={svgPaths.pf437f00} fill="#2D178B" />
        <path d={svgPaths.p2d13800} fill="#2D178B" />
        <path d={svgPaths.p1b4c0f80} fill="#2D178B" />
        <path d={svgPaths.p21c960f0} fill="#2D178B" />
        <path d={svgPaths.pe1e600} fill="#2D178B" />
        <path d={svgPaths.p23b33b80} fill="#2D178B" />
        <path d={svgPaths.pdea93f0} fill="#2D178B" />
        <path d={svgPaths.p1a427780} fill="#2D178B" />
        <path d={svgPaths.p19429b00} fill="#2D178B" />
        <path d={svgPaths.p2f549480} fill="#2D178B" />
        <path d={svgPaths.p12806a80} fill="#2D178B" />
      </ActiveHelper>
    </button>
  );
}

export { Active };

export default function Active1() {
  return <Active className="block cursor-pointer relative size-full" />;
}
